import {BaseFactory} from "../../../infrastructure/factories/base-factory";
import {CompetitorsResponseApiModel} from "../models/competitors.response-api-model";
import {CompetitionDomainModel} from "../../common/competition/models/competition-domain-model";
import {CompetitorsResponseDomainModel} from "../models/competitors.response-domain-model";
import {CompetitorCompetitionsDomainModel} from "../../common/competitor/models/competitor-competitions.domain-model";
import {CompetitorApiModel} from "../../common/competitor/models/competitor-api-model";
import {SportDomainModel} from "../../sports/models/sport-domain-model";
import {CountryDomainModel} from "../../common/country/models/country-domain-model";

export class CompetitorsFactory extends BaseFactory {

  static injectables = [...BaseFactory.injectables];

  createResponse(apiModel: CompetitorsResponseApiModel) {
    const responseApiModel: CompetitorsResponseApiModel = apiModel ? new CompetitorsResponseApiModel(apiModel) : null;
    return responseApiModel;
  }

  createCompetitorCompetitionsDomainModel(apiModel: CompetitorApiModel, countryDomainModel: CountryDomainModel, sportDomainModel: SportDomainModel, competitionDomainModels: Array<CompetitionDomainModel>): CompetitorCompetitionsDomainModel {
    return new CompetitorCompetitionsDomainModel(apiModel, countryDomainModel, sportDomainModel, competitionDomainModels)
  }

  createDomainModel(competitorCompetitionsDomainModel: Array<CompetitorCompetitionsDomainModel>, competitionsDomainModel: Array<CompetitionDomainModel>): CompetitorsResponseDomainModel {
    const domain: CompetitorsResponseDomainModel = new CompetitorsResponseDomainModel(competitorCompetitionsDomainModel, competitionsDomainModel);

    return domain;
  }
}

